import type { FC } from 'react';
import { Col, Divider, type FormInstance, Row } from 'antd';

import SecondaryLabel from '@/views/components/Labels/SecondaryLabel';

import type { CarrierInformationSettings } from '../../../types';
import ClaimsSettingsCarrierAddressForm from './claims-settings-carrier-address-form';
import ClaimsSettingsCarrierSettingsForm from './claims-settings-carrier-settings-form';

interface ClaimsSettingsCarrierFormProps {
  form: FormInstance<CarrierInformationSettings>;
}

const ClaimsSettingsCarrierForm: FC<ClaimsSettingsCarrierFormProps> = ({ form }) => {
  return (
    <>
      <ClaimsSettingsCarrierSettingsForm />
      <Row className="mt-10" gutter={15}>
        <Col md={12}>
          <Row className="my-5" gutter={15} align="middle">
            <Col>
              <SecondaryLabel>Overcharge Claim Address</SecondaryLabel>
            </Col>
            <Col className="flex-1 pt-3">
              <Divider className="m-0 border-top-border" />
            </Col>
          </Row>
          <ClaimsSettingsCarrierAddressForm addressType="ocClaimAddress" form={form} />
        </Col>
        <Col md={12}>
          <Row className="my-5" gutter={15} align="middle">
            <Col>
              <SecondaryLabel>Loss and Damage Claim Address</SecondaryLabel>
            </Col>
            <Col className="flex-1 pt-3">
              <Divider className="m-0 border-top-border" />
            </Col>
          </Row>
          <ClaimsSettingsCarrierAddressForm addressType="ldClaimAddress" form={form} />
        </Col>
      </Row>
    </>
  );
};

export default ClaimsSettingsCarrierForm;
